module.exports = __webpack_public_path__ + "static/images/contactless.35c66eb3984dac825eb11cc9f4dfb4d9.svg";